var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { sanitizer } from './sanitizer';
export * as deprecated from './deprecated';
export * from './types';
export { scrubber } from './scrubber';
export default function Masquerade(options) {
    if (options === void 0) { options = {}; }
    var requestSanitizer = sanitizer(__assign(__assign({}, options), { type: 'request' }));
    var responseSanitizer = sanitizer(__assign(__assign({}, options), { type: 'response' }));
    return {
        requestSanitizer: requestSanitizer,
        responseSanitizer: responseSanitizer,
    };
}
//# sourceMappingURL=index.js.map